import { makeActionCreator } from '../../../utilities'
import { PickupAddressConstants } from './pickupAddress.constants'

export const setTypeValue = makeActionCreator(PickupAddressConstants.SET_TYPE, 'typeValue')
export const setTypeOptions = makeActionCreator(PickupAddressConstants.SET_TYPE_OPTIONS, 'typeOptions')
export const setOtherType = makeActionCreator(PickupAddressConstants.SET_OTHER_TYPE, 'otherType')
export const setHospitalUnit = makeActionCreator(PickupAddressConstants.SET_HOSPITAL_UNIT, 'hospitalUnit')
export const setSceneGrid = makeActionCreator(PickupAddressConstants.SET_SCENE_GRID, 'sceneGrid')
export const setModeDescriptors = makeActionCreator(PickupAddressConstants.SET_MODE_DESCRIPTORS, 'modeDescriptors')
export const setPickupAddressModeDescriptorsPNNV = makeActionCreator(
  PickupAddressConstants.SET_PICKUP_ADDRESS_MODE_DESCRIPTORS_PNNV,
  'modeDescriptorsPNNV'
)
export const setLocation = makeActionCreator(PickupAddressConstants.SET_LOCATION, 'location')
export const setAddressLine1 = makeActionCreator(PickupAddressConstants.SET_ADDRESS_LINE1, 'addressLine1')
export const setAddressLine2 = makeActionCreator(PickupAddressConstants.SET_ADDRESS_LINE2, 'addressLine2')
export const setAptSuiteRoom = makeActionCreator(PickupAddressConstants.SET_APT_SUITE_ROOM, 'aptSuiteRoom')
export const setMilePostMajorRoadway = makeActionCreator(
  PickupAddressConstants.SET_MILE_POST_MAJOR_ROADWAY,
  'milePostMajorRoadway'
)
export const setCrossStreetDirections = makeActionCreator(
  PickupAddressConstants.SET_CROSS_STREET_DIRECTIONS,
  'crossStreetDirections'
)
export const setCity = makeActionCreator(PickupAddressConstants.SET_CITY, 'city')
export const setState = makeActionCreator(PickupAddressConstants.SET_STATE, 'state')
export const setZip = makeActionCreator(PickupAddressConstants.SET_ZIP, 'zip')
export const setCountry = makeActionCreator(PickupAddressConstants.SET_COUNTRY, 'country')
export const setCensusTract = makeActionCreator(PickupAddressConstants.SET_CENSUS_TRACT, 'censusTract')
export const setCounty = makeActionCreator(PickupAddressConstants.SET_COUNTY, 'county')
export const setMCD = makeActionCreator(PickupAddressConstants.SET_MCD, 'mCD')
export const setReferringMD = makeActionCreator(PickupAddressConstants.SET_REFERRING_MD, 'referringMD')
export const setReferringMdOther = makeActionCreator(PickupAddressConstants.SET_REFERRING_MD_OTHER, 'referringMdOther')
export const setReferringRN = makeActionCreator(PickupAddressConstants.SET_REFERRING_RN, 'referringRN')
export const setReferringUSNG = makeActionCreator(PickupAddressConstants.SET_REFERRING_USNG, 'referringUSNG')
export const setReferringGPSN = makeActionCreator(PickupAddressConstants.SET_REFERRING_GPS_N, 'referringGPSN')
export const setReferringGPSE = makeActionCreator(PickupAddressConstants.SET_REFERRING_GPS_E, 'referringGPSE')
export const setRFT = makeActionCreator(PickupAddressConstants.SET_RFT, 'RFT')
export const setResponseMode = makeActionCreator(PickupAddressConstants.SET_RESPONSE_MODE, 'responseMode')
export const savePickupAddress = makeActionCreator(PickupAddressConstants.SAVE_PICKUP_ADDRESS)
export const setResponse = makeActionCreator(PickupAddressConstants.SET_RESPONSE, 'response')
export const setPickupAddressState = makeActionCreator(PickupAddressConstants.SET_PICKUP_ADDRESS_STATE, 'pickupAddress')
export const resetPickupAddressState = makeActionCreator(PickupAddressConstants.RESET_PICKUP_ADDRESS_STATE)
export const calculateReferringUsng = makeActionCreator(PickupAddressConstants.CALCULATE_REFERRING_USNG)
export const setCommonAddress = makeActionCreator(PickupAddressConstants.SET_COMMON_ADDRESS, 'commonAddress')
export const setStateIds = makeActionCreator(PickupAddressConstants.SET_STATE_IDS, 'stateIds')
export const setPickupAddressDefaults = makeActionCreator(
  PickupAddressConstants.SET_PICKUP_ADDRESS_DEFAULTS,
  '__areDefaultsSet'
)
export const setPickupAddressDefaultsWithResponseMode = makeActionCreator(
  PickupAddressConstants.SET_PICKUP_ADDRESS_DEFAULTS_WITH_RESPONSE_MODE,
  'responseMode'
)
export const setDefaultHospitalCode = makeActionCreator(PickupAddressConstants.SET_DEFAULT_HOSPITAL_CODE)
export const setDefaultEMSCode = makeActionCreator(PickupAddressConstants.SET_DEFAULT_EMS_CODE)

// Used by both Pickup and Destination
export const getCountyOptions = makeActionCreator(PickupAddressConstants.GET_COUNTY_OPTIONS)
